import { useTranslation } from 'react-i18next';
import { useEditGroup } from '../EditGroupPage/useEditGroup';
import { GroupPreceptorsTable } from '../../../components/GroupPreceptorsTable';

export const ViewGroupContainer = () => {
	const { t } = useTranslation();
	const { group } = useEditGroup();
	const groupName = group?.groupName;
	const preceptorGroupMembersWithoutKey = group?.preceptorGroupMembers;
	const mentor = group?.mentor;
	const preceptorGroupMembers =
		preceptorGroupMembersWithoutKey &&
		preceptorGroupMembersWithoutKey.map((preceptor) => ({
			...preceptor,
			key: preceptor.id,
		}));

	return (
		<div className="p-8">
			<h2>{t('viewGroupWithGroupName', { groupName })}</h2>
			<GroupPreceptorsTable
				groupPreceptors={preceptorGroupMembers}
				mentor={mentor}
			/>
		</div>
	);
};
